import { render, staticRenderFns } from "./templateRevisionHistory.vue?vue&type=template&id=5aae0c42&scoped=true&"
import script from "./templateRevisionHistory.vue?vue&type=script&lang=js&"
export * from "./templateRevisionHistory.vue?vue&type=script&lang=js&"
import style0 from "./templateRevisionHistory.vue?vue&type=style&index=0&id=5aae0c42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aae0c42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aae0c42')) {
      api.createRecord('5aae0c42', component.options)
    } else {
      api.reload('5aae0c42', component.options)
    }
    module.hot.accept("./templateRevisionHistory.vue?vue&type=template&id=5aae0c42&scoped=true&", function () {
      api.rerender('5aae0c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/incomingInspectionMgr/nskTemplateMgr/components/templateRevisionHistory.vue"
export default component.exports